import React, {Component} from 'react'
import Cannonicalize from '../Cannonicalize'
import ClientSideCacheController from '../ClientSideCacheController'
import Analytics from '../Analytics';

class BaronHourlyTemperatures extends  Component{
  constructor(props){
    super(props)
    this.state = {
      hourly: [],
      lowToday: -999,
      highToday: -999,
      city: '',
      state: ''

    }
    this.marginTop = 51
    this.affiliate = props.affiliate
  }

  componentWillMount() {
    try {
      this.setState(this.setExtremes(Cannonicalize.hourlyForecast(this.props.FRN_rawResponses[0].data)))
    } catch (e) {
      e.message = ' in BaronHourlyTemperatures'
      Analytics.reportError(e)
    }
    if (typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    // ClientSideCacheController.get('forecast').then((data) => {
    //   this.setState(this.massageData(data))
    // })

    ClientSideCacheController.get('hourlyForecast').then((data)=>{
      let state = this.setExtremes(data)
      // console.log(state );
      this.setState(state);
    })
  }


  setExtremes(hourly){
    let state = {}
    state.highToday = -999
    state.lowToday = 999;
    state.city = hourly[0].city
    state.state = hourly[0].state
    state.hourly = hourly.slice(0,24).map((a,i,all)=>{

      if(a.temperature.value > state.highToday)
        state.highToday = a.temperature.value
      if(a.temperature.value < state.lowToday)
        state.lowToday = a.temperature.value

      return a
    })
    return state
  }


  barGraphStyle(d){
    let percentBottomOffset = 0.19
    let scale =(1-percentBottomOffset)/(this.state.highToday - this.state.lowToday)
    let percent = d.temperature.value - this.state.lowToday
    percent = percent * scale + percentBottomOffset;
    percent = Math.round(percent * 100)
    return {
      height: '140px',
      background: `linear-gradient(to top, rgb(${155+ percent}, 50, ${155 - percent}) ${percent}%, transparent ${percent}%)`,
      marginTop: this.marginTop + 'px'
    }
  }

  shortTime(h){
    let t = new Date(h.valid_begin)
    let hours =  t.getHours()
    if(hours == 12)
       hours = '12pm'
     else if(hours > 12)
       hours = (hours - 12) + 'pm'
     else if(hours == 0)
       hours = '12am'
     else
       hours = hours + 'am'
    return hours
  }


  render () {
    if(this.state.hourly.length < 1)
      return null
  	return (
      <div className="gnm-hourly-temperatures hidden-xs hidden-sm"  >
        <h5 className='white-at-small'>24hr Temperature Forecast for {this.state.city}, {this.state.state}</h5>
        <div className="chart">
          {this.state.hourly.map((h,i,a)=>{
            return(
              <div className='bar' style={this.barGraphStyle(h)} key={i}>
                <div className='short-time' style={{top: '-'+ this.marginTop + 'px'}}>{this.shortTime(h)}</div>
                <div className='temperature'>{h.temperature.value}<sup>&deg;</sup></div>
              </div>
            )
          })}
        </div>
      </div>

    )

  }
}

export default BaronHourlyTemperatures



// WEBPACK FOOTER //
// ./app/components/custom/ssr/BaronHourlyTemperatures/index.js